import React, { useState, useRef } from 'react';
import getPosition from './getPosition';
import getTipContent from './getTipContent';
import styles from './tooltip.module.css';
export function Tooltip(_a) {
    var _b = _a.position, position = _b === void 0 ? 'top' : _b, _c = _a.message, message = _c === void 0 ? '' : _c, _d = _a.isMultiline, isMultiline = _d === void 0 ? false : _d, children = _a.children;
    var _e = useState(false), isVisible = _e[0], setIsVisible = _e[1];
    var node = useRef(null);
    var tooltip = useRef(null);
    var showTooltip = function (e) {
        if (!node.current)
            return;
        var result = getPosition(e.currentTarget, tooltip.current, 'top', 'top', {});
        tooltip.current.style.left = result.position.left + 'px';
        tooltip.current.style.top = result.position.top + 'px';
        setIsVisible(true);
    };
    var hideTooltip = function () {
        setIsVisible(false);
    };
    var classNames = "".concat(styles.message, " ").concat(isVisible ? styles.show : '', " ").concat(styles['place_' + position]);
    var content = getTipContent(message, isMultiline);
    return (React.createElement("div", { className: styles.tooltip },
        React.createElement("div", { className: styles.toggler, onMouseOverCapture: showTooltip, onMouseOut: hideTooltip, ref: node }, children),
        React.createElement("div", { style: { visibility: 'hidden', opacity: 0, position: 'fixed' }, className: classNames, ref: tooltip }, content)));
}
//# sourceMappingURL=Tooltip.js.map